import { Injectable } from '@angular/core';
import { providerManagements } from '@app/models/providerManagements';
import { ProviderService } from '@app/services/api/provider.service';

import {
    ManagementActionTypes,
    LoadFail,
    LoadSuccess,
    Load,
    Delete,
    DeleteSuccess,
    DeleteFail,
    Create,
    CreateSuccess,
    CreateFail,
    Update,
    UpdateSuccess,
    UpdateFail,
    AddResponsable,
    AddResponsableSuccess,
    AddResponsableFail,
    DeleteResponsable,
    DeleteResponsableSuccess,
    DeleteResponsableFail
} from '@core/actions/management.action';
import * as fromProvidersActions from '@core/actions/provider.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, concatMap, tap } from 'rxjs/operators';
import { FlashService } from '@app/services/flash.service';

@Injectable()
export class ManagementEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(ManagementActionTypes.Load),
    switchMap(action => {
        return this.providersApi.getManagement(action.followGroupId, action.page).pipe(
            map((managmenet: any) => {
              if(action.mode){
                return new LoadSuccess(managmenet, action.mode)
              }else{
                const page = 0
                const filter = 0
                return new fromProvidersActions.Load(page, filter)
              }
            }),
            catchError(error => of(new LoadFail(error)))
    )
    })
  );

  @Effect()
  delete$: Observable<Action> = this.actions$.pipe(
    ofType<Delete>(ManagementActionTypes.Delete),
    switchMap(action => {
        return this.providersApi.deleteManagement(action.id).pipe(
          map((managmenet: any) => {
            if(action && action.mode){
              return new LoadSuccess(managmenet)
            }else{
              const page = 0
              const filter = 0
              return new fromProvidersActions.Load(page, filter)
            }
          }),
            catchError(error => of(new LoadFail(error)))
    )
    })
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(ManagementActionTypes.Create),
    switchMap(action => {
        return this.providersApi.createManagement(action.data).pipe(
          map((managmenet: any) => {
            if(action && action.mode){
              return new LoadSuccess(managmenet)
            }else{
              const page = 0
              const filter = 0
              return new fromProvidersActions.Load(page, filter)
            }
          }),
            catchError(error => of(new LoadFail(error)))
    )
    })
  );

  @Effect()
  providerUpdate$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(ManagementActionTypes.Update),
    map(action => [action.id, action.data]),
    concatMap(([id, data]) =>
      this.providersApi.updateManagement(id, data).pipe(
        map(product => {
          this.fs.emit({
            type: 'success',
            message: 'Gerencia editado correctamente'
          });
          return new UpdateSuccess(product);
        }),
        catchError(error => of(new UpdateFail(error)))
      )
    )
  );

  @Effect()
  updateSuccess$ = this.actions$.pipe(
    ofType<AddResponsableSuccess>(ManagementActionTypes.UpdateSuccess),
    map((action) => {
      if(action && action.data && action.data.followGroupsId){
        return new Load(action.data.followGroupsId, 0, 'managementView')
      }
    })
  );  

  @Effect()
  addResponsable$: Observable<Action> = this.actions$.pipe(
    ofType<AddResponsable>(ManagementActionTypes.AddResponsable),
    map(action => action.data),
    switchMap(data =>
      this.providersApi.addUserProvider(data).pipe(
        map((savedProvider: any) => new AddResponsableSuccess(savedProvider)),
        catchError(error => of(new AddResponsableFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  addResponsableSuccess$ = this.actions$.pipe(
    ofType<AddResponsableSuccess>(ManagementActionTypes.AddResponsableSuccess),
    map(action => action.data),
    tap(res =>
      this.fs.emit({
        message: 'Usuario/s asignado correctamente',
        type: 'success'
      })
    )
  );

  @Effect({ dispatch: false })
  addResponsableFail$ = this.actions$.pipe(
    ofType<AddResponsableFail>(ManagementActionTypes.AddResponsableFail),
    map(action => action.data),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo asignar el usuario',
        type: 'danger'
      })
    )
  );

  @Effect()
  deleteResponsable$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteResponsable>(ManagementActionTypes.DeleteResponsable),
    map(action => [action.id, action.data]),
    concatMap(([id, data]) =>
      this.providersApi.deleteUserProvider(id, data).pipe(
        map(product => {
          this.fs.emit({
            type: 'success',
            message: 'Usuario desasignado correctamente'
          });
          return new DeleteResponsableSuccess(product);
        }),
        catchError(error => of(new DeleteResponsableFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  deleteResponsableFail$= this.actions$.pipe(
    ofType<DeleteResponsableFail>(ManagementActionTypes.DeleteResponsableFail),
    map((action) => {
      if(action.data.error.error.message){
        this.fs.emit({ type: 'danger', message: action.data.error.error.message });
      }else{
        this.fs.emit({ type: 'danger', message: 'No se puede actualizar el proveedor' });
      }
    })
  );


  constructor(
    private actions$: Actions,
    private providersApi: ProviderService,
    private fs: FlashService
  ) {}
}
